module.exports = __webpack_public_path__ + "img/imgImgHome00.3cfa9c9a.svg";